<template>
  <v-layout column class="px-4 pt-4">
    <CaseConfigHeader
        :header="emailTemplate ? emailTemplate.name : 'Email Template'"
        subheader="Email Template"
    ></CaseConfigHeader>    
    <v-layout pt-4 px-4 style="background:white;">
      <div>
        <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="maximise-btn"
            @click.stop="maximised = !maximised ; $vuetify.goTo('#emails-top', goToOptionsMaximiseTemplates)"
            style="position:absolute; z-index:9; right:35px; top:0"
            icon>
          <v-icon color="secondary">fullscreen</v-icon>
          </v-btn>
        </template>
        <span>Maximise Panel</span>
        </v-tooltip>
        <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            class="minimise-btn"
            @click.stop="maximised = !maximised ; $vuetify.goTo('#min-scroll-to', goToOptionsMinimiseTemplates)"
            style="position:absolute; z-index:9; right:35px; top:0"
            icon>
          <v-icon color="secondary">fullscreen_exit</v-icon>
          </v-btn>
        </template>
        <span>Minimise Panel</span>
        </v-tooltip>
      </div>
      <v-flex>
        <v-layout row>
          <v-btn
            :ripple="false" flat class="ma-0 text-link-button"
            v-on:click="templateHeaderToggled = !templateHeaderToggled">
            <v-icon small color="secondary" class="mr-2"> {{ templateHeaderToggled ? 'visibility_off' : 'visibility' }}</v-icon>
            {{ templateHeaderToggled ? 'Hide template header' : 'View template header' }}
          </v-btn>
          <v-spacer/>
          <v-btn color="secondary" @click="returnToConfig()">Back to Email Templates</v-btn>
        </v-layout>
        <v-slide-y-transition>
          <v-layout column wrap class="mt-1" v-if="templateHeaderToggled && emailTemplate">
            <v-flex xs12 sm6 mt-2>
              <v-text-field label="Template name" box v-model="emailTemplate.name" v-on:change="recordChange()"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 mt-2>
              <v-autocomplete label="Template wrapper" box :items="wrapperTemplates"
                item-text="name"
                item-value="id"
                v-model="emailTemplate.templateWrapperId"
                v-on:change="recordChange()"
              ></v-autocomplete>
              <v-checkbox
                color="secondary"
                label="Used as an email body"
                v-model="emailTemplate.emailBodyTemplate"
                v-on:change="recordChange()"
                class="ma-0">
              </v-checkbox>
              <v-checkbox
                color="secondary"
                label="Default email body template"
                v-model="emailTemplate.defaultEmailBodyTemplate"
                v-on:change="recordChange()"
                v-if="emailTemplate.emailBodyTemplate"
                class="ma-0">
              </v-checkbox>
            </v-flex>
          </v-layout>
        </v-slide-y-transition>


        <v-layout row>
                  <v-flex md6 pt-4 pr-4>
          <!-- <v-layout wrap pa-0 mb-2>
            <p class="pt-3" v-if="emailTemplate">Last saved {{emailTemplate.updateAt}}</p>
          </v-layout> -->
          <h3>Source</h3>
          <div v-if="emailTemplate" class="template-editor-container mt-2 mb-4">
            <wysiwyg 
              v-if="!sourceMode"
              v-model="templateContent"
              ref="wysiwygEditor"
              placeholder="Enter your email template HTML here...">
            </wysiwyg>
            <v-textarea
              v-if="sourceMode"
              v-model="sourceHtml"
              @input="updateTemplateFromSource"
              box
              auto-grow
              rows="15"
              class="source-html-editor"
              placeholder="Edit HTML source code here...">
            </v-textarea>
          </div>
          <v-layout row xs12 sm6>
            <v-btn class="ma-0 mt-4 mr-2" color="secondary" :disabled="!hasChanged" @click="saveTemplate()">Save</v-btn>
            <v-btn class="ma-0 mt-4" color="secondary" @click="preparePreview()">Preview</v-btn>
          </v-layout>
          <v-layout wrap fluid mt-4 style="position:relative">
            <v-flex
              class="mb-4" xs12 md12
              :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-2': $vuetify.breakpoint.mdAndUp,  list: listView}">
              <h3>Input</h3>
              <v-autocomplete
                :items="selectCaseItems"
                v-model="selectedCase"
                @change="loadSelectedCase()"
                dense box
                append-icon="keyboard_arrow_down"
                class="pt-3"
                label="Select an input case"
                style="width:33% !important;">
              </v-autocomplete>


              <Loading :isLoading="loadingCase"></Loading>
              <edit-code-pane
                v-if="!loadingCase"
                ref="inputCode"
                :code="htmlValueInput"
                language="json"
                v-on:update-code="updateHtmlValueInput"
                style="background:rgb(240, 240, 240) !important">
              </edit-code-pane>
            </v-flex>            
          </v-layout>
        </v-flex>
        <v-flex md6 pt-4>
          <h3>Preview</h3>
          <div v-if="!previewURL" style="padding: 20px; color: #999;">
            <p>No preview URL set. Preview URL: {{ previewURL }}</p>
          </div>
          <iframe 
            v-if="previewURL"
            ref="previewIframe"
            style="min-width: 100%; width: 1px; min-height: 400px; height: auto; border: 1px solid #AAAAAA;" 
            frameborder="0" 
            :src="previewURL"
            @load="onIframeLoad"
            @error="onIframeError">
          </iframe>
          <div v-if="preparingPreview" style="padding: 20px;">
            <p>Preparing preview...</p>
          </div>
        </v-flex>
        </v-layout>


      </v-flex>
    </v-layout>
    <v-layout mt-2 row>
      <v-btn color="error" @click="deleteDialog = true" dark class="ml-0">
        <v-icon>delete</v-icon>&emsp;Delete Email Template
      </v-btn>
      <delete-dialog :isOpen="deleteDialog" itemType="e-mail" v-on:delete-item="deleteEmail"></delete-dialog>
    </v-layout>
  </v-layout>
</template>

<script>
import Loading from "@/components/shared/Loading.vue"
import Helpers from '@/helpers.js'
import EditCodePane from '@/components/shared/editCodePane.vue'
import DeleteDialog from "@/components/shared/deleteDialog"
import CaseConfigHeader from "@/components/cases/case-config/CaseConfigHeader.vue"
import { mapState } from 'vuex'

export default {
  name: "email-template",
  components: { Loading, EditCodePane, DeleteDialog, CaseConfigHeader },
  data() {
    return {
      preview: "",
      deleteDialog: false,
      previewToggled: false,
      loadingCase: false,
      hasChanged: false,
      preparingPreview: false,
      selectCaseFrom: null,
      selectCaseFromItems: ["Last 10 viewed cases"],
      selectedCase: null,
      htmlValueInput: "Select an input case",
      maximised: false,
      templateHeaderToggled: "",
      columnView: true,
      listView: false,
      goToOptionsMaximiseTemplates: { duration: 500, offset: -14, easing: "easeInOutCubic" },
      goToOptionsMinimiseTemplates: { duration: 500, offset: -150, easing: "easeInOutCubic" },
      selectedWrapper: undefined,
      emailBodyTemplate: false,
      emailTemplate: undefined,
      previewURL: undefined,
      livePreviewEnabled: true,
      previewDebounceTimer: null,
      previewBlobURL: null,
      sourceMode: false,
      sourceHtml: ''
    }
  },
  mounted() {
    console.log('[EmailTemplate] Component mounted')
    // Initialize sourceHtml with current content
    if (this.emailTemplate) {
      this.sourceHtml = this.templateContent || ''
    }
    console.log('[EmailTemplate] Initial state:', {
      caseType: this.caseType,
      emailTemplates: this.caseType && this.caseType.emailTemplates,
      emailId: this.emailId,
      emailTemplateId: this.caseType && this.caseType.emailTemplates && this.caseType.emailTemplates.map(et => et.id)
    })
    
    if (this.caseType && this.caseType.emailTemplates && this.emailId) {
      this.emailTemplate = this.caseType.emailTemplates.find(et => parseInt(et.id) === parseInt(this.emailId))
      console.log('[EmailTemplate] Found emailTemplate:', this.emailTemplate)
      
      if (this.emailTemplate) {
        // Only use sampleInput if it's valid JSON, otherwise use placeholder
        const sampleInput = this.emailTemplate.sampleInput
        if (sampleInput && sampleInput !== "Select an input case" && sampleInput.trim() !== "") {
          // Validate it's valid JSON
          try {
            JSON.parse(sampleInput)
            this.htmlValueInput = sampleInput
          } catch (e) {
            console.warn('[EmailTemplate] Invalid JSON in sampleInput, using placeholder:', e.message)
            this.htmlValueInput = "Select an input case"
          }
        } else {
          this.htmlValueInput = "Select an input case"
        }
        console.log('[EmailTemplate] htmlValueInput set to:', this.htmlValueInput)
        console.log('[EmailTemplate] Calling setPreviewURL from mounted...')
        this.setPreviewURL()
        console.log('[EmailTemplate] Initial previewURL set to:', this.previewURL)
        // Sync sourceHtml after template is loaded
        this.sourceHtml = this.templateContent || ''
        // Add source toggle button to wysiwyg toolbar
        this.$nextTick(() => {
          this.addSourceButtonToToolbar()
        })
      } else {
        console.warn('[EmailTemplate] Cant initialise - email template not found', {
          emailId: this.emailId,
          availableIds: this.caseType.emailTemplates.map(et => et.id)
        })
      }
    } else {
      console.warn('[EmailTemplate] Cant initialise - missing required data', {
        hasCaseType: !!this.caseType,
        hasEmailTemplates: !!(this.caseType && this.caseType.emailTemplates),
        emailId: this.emailId
      })
    }
  },
  computed: {
    ...mapState({
      flaggedCases: state => state.homepage.flagged_cases,
      recentCases: state => state.homepage.recent_cases,
      currentCase: state => state.cases.currentlySelected.case,
      caseType: state => state.caseTypes.current,
      allCaseTypeEmailTemplates: state => state.caseTypes.current.emailTemplates,
      caseTypeId: state => state.cbroute.params.case_type_id,
      emailId: state => state.cbroute.params.email_id
    }),
    wrapperTemplates() {
      return (this.allCaseTypeEmailTemplates || []).filter(et => !et.emailBodyTemplate)
    },
    emailData() {
      const ids = this.caseType.emailTemplates.map(email => email.id)
      const index = ids.indexOf(parseInt(this.emailId))
      return this.caseType.emailTemplates[index]
    },
    recentCasesOfType() {
      if (this.recentCases && this.caseType) {
        return this.recentCases.filter(rc => rc.caseTypeId === this.caseType.id)
      }
      return []
    },
    selectCaseItems() {
      return this.recentCasesOfType.map(c => ({ text: c.caseType + ": " + c.title, value: c }))
    },
    templateContent: {
      get() {
        return this.emailTemplate ? (this.emailTemplate.template || "") : ""
      },
      set(value) {
        if (this.emailTemplate) {
          this.emailTemplate.template = value
          this.hasChanged = true
          // Trigger live preview update
          this.renderLivePreview()
        }
      }
    }
  },
  watch: {
    currentCase() {
      if (this.currentCase && this.loadingCase) { // Prevents all email templates updating on selection
        this.setupSelectedCase()
      }
    },
    emailId() {
      console.log('[EmailTemplate] emailId watcher triggered, new emailId:', this.emailId)
      if (this.caseType && this.caseType.emailTemplates && this.emailId) {
        this.emailTemplate = this.caseType.emailTemplates.find(et => parseInt(et.id) === parseInt(this.emailId))
        console.log('[EmailTemplate] Found emailTemplate in watcher:', this.emailTemplate)
        
        // Sync source HTML when email template changes
        if (this.emailTemplate && !this.sourceMode) {
          this.sourceHtml = this.templateContent || ''
        }
        
        if (this.emailTemplate) {
          // Only use sampleInput if it's valid JSON, otherwise use placeholder
          const sampleInput = this.emailTemplate.sampleInput
          if (sampleInput && sampleInput !== "Select an input case" && sampleInput.trim() !== "") {
            // Validate it's valid JSON
            try {
              JSON.parse(sampleInput)
              this.htmlValueInput = sampleInput
            } catch (e) {
              console.warn('[EmailTemplate] Invalid JSON in sampleInput (watcher), using placeholder:', e.message)
              this.htmlValueInput = "Select an input case"
            }
          } else {
            this.htmlValueInput = "Select an input case"
          }
          console.log('[EmailTemplate] Calling setPreviewURL from emailId watcher...')
          this.setPreviewURL()
          // Re-add button to toolbar when email template changes
          this.$nextTick(() => {
            this.addSourceButtonToToolbar()
          })
        } else {
          console.warn('[EmailTemplate] Cant initialise - email template not found in watcher')
        }
      } else {
        console.warn('[EmailTemplate] Cant initialise in watcher - missing required data')
      }      
    },
    previewURL(newVal, oldVal) {
      console.log('[EmailTemplate] previewURL watcher triggered')
      console.log('[EmailTemplate] Old previewURL:', oldVal)
      console.log('[EmailTemplate] New previewURL:', newVal)
      console.log('[EmailTemplate] PreviewURL changed:', newVal !== oldVal)
      
      // Check if iframe exists after Vue updates the DOM
      this.$nextTick(() => {
        const iframe = this.$refs.previewIframe || (this.$el && this.$el.querySelector('iframe'))
        console.log('[EmailTemplate] After previewURL change, iframe found:', !!iframe)
        if (iframe) {
          console.log('[EmailTemplate] Iframe src attribute:', iframe.getAttribute('src'))
          console.log('[EmailTemplate] Iframe src property:', iframe.src)
          console.log('[EmailTemplate] Expected previewURL:', newVal)
          console.log('[EmailTemplate] Iframe src matches:', iframe.src === newVal || iframe.getAttribute('src') === newVal)
        }
      })
    }
  },
  methods: {
    toggleSourceMode() {
      if (!this.sourceMode) {
        // Switching to source mode - get current HTML content
        this.sourceHtml = this.templateContent || ''
      } else {
        // Switching back to visual mode - update template content
        this.templateContent = this.sourceHtml
        // Re-add button to toolbar when switching back to visual mode
        this.$nextTick(() => {
          this.addSourceButtonToToolbar()
        })
      }
      this.sourceMode = !this.sourceMode
    },
    updateTemplateFromSource() {
      // Update the template content when source is edited
      if (this.sourceMode && this.emailTemplate) {
        this.emailTemplate.template = this.sourceHtml
        this.hasChanged = true
        // Trigger live preview update
        this.renderLivePreview()
      }
    },
    addSourceButtonToToolbar() {
      if (this.sourceMode) return // Don't add button in source mode
      
      const editorContainer = this.$el.querySelector('.template-editor-container')
      if (!editorContainer) return
      
      const toolbar = editorContainer.querySelector('.editr--toolbar')
      if (!toolbar) return
      
      // Check if button already exists
      if (toolbar.querySelector('.source-toggle-toolbar-btn')) return
      
      // Create the button
      const button = document.createElement('a')
      button.className = 'source-toggle-toolbar-btn'
      button.title = 'Source'
      button.innerHTML = '<i class="material-icons" style="font-size: 16px; line-height: 32px;">code</i>'
      button.style.cssText = 'display: inline-block; width: 30px; color: #333; cursor: pointer; text-align: center; line-height: 1;'
      button.addEventListener('click', (e) => {
        e.preventDefault()
        this.toggleSourceMode()
      })
      
      // Add separator if there are other buttons
      if (toolbar.children.length > 0) {
        const separator = document.createElement('a')
        separator.className = 'vw-btn-separator'
        separator.innerHTML = '<i class="vw-separator"></i>'
        toolbar.appendChild(separator)
      }
      
      // Add button to toolbar (at the end)
      toolbar.appendChild(button)
    },
    async renderLivePreview() {
      if (!this.livePreviewEnabled || !this.emailTemplate || !this.emailTemplate.id) {
        return
      }
      
      // Clear previous debounce timer
      if (this.previewDebounceTimer) {
        clearTimeout(this.previewDebounceTimer)
      }
      
      // Debounce the preview update (wait 500ms after user stops typing)
      this.previewDebounceTimer = setTimeout(async () => {
        try {
          this.preparingPreview = true
          
          // Get current template content and input
          const templateContent = this.emailTemplate.template || ""
          let inputData = {}
          
          // Parse current input if it's valid JSON
          if (this.htmlValueInput && this.htmlValueInput !== "Select an input case" && this.htmlValueInput.trim() !== "") {
            try {
              inputData = JSON.parse(this.htmlValueInput)
            } catch (e) {
              // Invalid JSON, use empty object
              inputData = {}
            }
          }
          
          // Call render endpoint
          const cfg = require('@/cfg').default
          const apiEndpoint = cfg.apiEndPoint()
          const token = window.localStorage.getItem('session')
          const url = `${apiEndpoint}/tprint/templates/${this.emailTemplate.id}/render`
          
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
              template: templateContent,
              input: inputData
            })
          })
          
          if (!response.ok) {
            // If 404, the backend route might not be available yet - fall back to saved preview
            if (response.status === 404) {
              console.warn('[EmailTemplate] Render endpoint not available (404), falling back to saved preview')
              this.livePreviewEnabled = false
              this.setPreviewURL() // Use the old preview method
              return
            }
            throw new Error(`Preview render failed: ${response.status} ${response.statusText}`)
          }
          
          const html = await response.text()
          
          // Clean up old blob URL if it exists
          if (this.previewBlobURL) {
            URL.revokeObjectURL(this.previewBlobURL)
          }
          
          // Create blob URL from rendered HTML
          const blob = new Blob([html], { type: 'text/html' })
          this.previewBlobURL = URL.createObjectURL(blob)
          this.previewURL = this.previewBlobURL
          
          console.log('[EmailTemplate] Live preview updated')
        } catch (error) {
          console.error('[EmailTemplate] Error rendering live preview:', error)
          // Fall back to saved preview on error
          if (error.message && error.message.includes('404')) {
            console.warn('[EmailTemplate] Render endpoint not available, disabling live preview')
            this.livePreviewEnabled = false
            this.setPreviewURL() // Use the old preview method
          }
        } finally {
          this.preparingPreview = false
        }
      }, 500)
    },
    setPreviewURL() {
      console.log('[EmailTemplate] setPreviewURL called')
      console.log('[EmailTemplate] emailTemplate:', this.emailTemplate)
      
      if (!this.emailTemplate || !this.emailTemplate.id) {
        console.warn('[EmailTemplate] setPreviewURL: Missing emailTemplate or id', {
          emailTemplate: this.emailTemplate,
          hasId: this.emailTemplate && this.emailTemplate.id
        })
        return
      }
      
      // If live preview is enabled, use live preview instead
      if (this.livePreviewEnabled) {
        this.renderLivePreview()
        return
      }
      
      const templateId = this.emailTemplate.id
      const timestamp = new Date().getTime()
      const path = `/tprint/templates/${templateId}/${timestamp}`
      console.log('[EmailTemplate] Generated path:', path)
      
      const token = window.localStorage.getItem('session')
      console.log('[EmailTemplate] Token exists:', !!token, 'Token length:', token && token.length)
      
      const isLocalhost = window.location.href.startsWith("http://localhost")
      console.log('[EmailTemplate] Is localhost:', isLocalhost, 'Current URL:', window.location.href)
      
      const baseURL = isLocalhost ? `http://localhost:6543${path}` : path
      console.log('[EmailTemplate] Base URL:', baseURL)
      
      const finalURL = `${baseURL}?token=${token}`
      console.log('[EmailTemplate] Final preview URL:', finalURL)
      
      this.previewURL = finalURL
      console.log('[EmailTemplate] previewURL set to:', this.previewURL)
    },
    recordChange() {
      this.hasChanged = true
    },
    async deleteEmail(shouldDelete) {
      this.deleteDialog = false
      if (shouldDelete) {
        const result = await this.$store.dispatch("deleteEmailTemplate", { emailTemplateId: parseInt(this.emailId), caseTypeId: this.caseType.id })
        if (!result.error) {
          this.returnToConfig()
        }
      }
    },
    returnToConfig() {
      this.$router.push({ name: 'CaseConfig', params: { case_type_id: this.caseTypeId, config_tab: "Emails" } })
    },
    formatDate(datetime) {
      if (!datetime) { return "never" }
      const date = Helpers.formatEventDateSimple(datetime)
      const time = new Date(datetime).toLocaleTimeString().split(":")
      return date + " @ " + time[0] + ":" + time[1]
    },
    loadSelectedCase() {
      this.loadingCase = true
      this.$store.dispatch("getCurrentlySelectedCase", { caseId: this.selectedCase.id })
    },
    setupSelectedCase() {
      const preppedCase = this.currentCase
      const props = this.currentCase.properties
      Object.keys(props).forEach(function(prop) { preppedCase[prop] = props[prop] })
      delete preppedCase.properties
      delete preppedCase.schema

      this.htmlValueInput = JSON.stringify(preppedCase, null, 2)
      this.loadingCase = false
    },
    async preparePreview() {
      console.log('[EmailTemplate] preparePreview called')
      console.log('[EmailTemplate] Current state:', {
        emailTemplate: this.emailTemplate,
        emailTemplateId: this.emailTemplate && this.emailTemplate.id,
        htmlValueInput: this.htmlValueInput,
        previewURL: this.previewURL,
        preparingPreview: this.preparingPreview
      })
      
      this.preparingPreview = true
      console.log('[EmailTemplate] preparingPreview set to true')
      
      try {
        console.log('[EmailTemplate] Calling setPreviewURL...')
        this.setPreviewURL()
        console.log('[EmailTemplate] setPreviewURL completed, new previewURL:', this.previewURL)
        
        // Check if iframe exists
        const iframe = this.$el && this.$el.querySelector('iframe')
        console.log('[EmailTemplate] Iframe element found:', !!iframe, iframe)
        
        if (iframe) {
          console.log('[EmailTemplate] Iframe current src:', iframe.src)
          console.log('[EmailTemplate] Iframe will be updated to:', this.previewURL)
          
          // Force iframe reload by setting src
          iframe.src = this.previewURL
          console.log('[EmailTemplate] Iframe src manually set to:', iframe.src)
          
          // Add iframe load event listeners for debugging
          iframe.onload = () => {
            console.log('[EmailTemplate] Iframe loaded successfully')
            console.log('[EmailTemplate] Iframe contentWindow:', iframe.contentWindow)
            try {
              console.log('[EmailTemplate] Iframe contentDocument:', iframe.contentDocument)
            } catch (e) {
              console.warn('[EmailTemplate] Cannot access iframe contentDocument (cross-origin?):', e.message)
            }
          }
          
          iframe.onerror = (error) => {
            console.error('[EmailTemplate] Iframe load error:', error)
          }
        } else {
          console.warn('[EmailTemplate] Iframe element not found in DOM')
        }

        // let payload = this.htmlValueInput
        // if (!this.htmlValueInput || this.htmlValueInput === "Select an input case") { payload = "{}" }
        // const result = await this.$store.dispatch("renderEmailTemplate", { id: this.emailData.id, payload: payload })
        // this.preview = result.rendering
      } catch (error) {
        console.error('[EmailTemplate] Error in preparePreview:', error)
        console.error('[EmailTemplate] Error stack:', error.stack)
      } finally {
        this.preparingPreview = false
        console.log('[EmailTemplate] preparingPreview set to false')
      }
    },
    async saveTemplate() {
      if (this.emailTemplate) {
        // Ensure sampleInput is valid JSON before saving
        if (this.emailTemplate.sampleInput) {
          const sampleInput = this.emailTemplate.sampleInput.trim()
          if (sampleInput === "Select an input case" || sampleInput === "") {
            this.emailTemplate.sampleInput = "{}"
          } else {
            // Validate it's valid JSON
            try {
              JSON.parse(sampleInput)
              // Keep the value as is
            } catch (e) {
              console.warn('[EmailTemplate] Invalid JSON in sampleInput during save, using {}:', e.message)
              this.emailTemplate.sampleInput = "{}"
            }
          }
        } else {
          this.emailTemplate.sampleInput = "{}"
        }
        await this.$store.dispatch("updateEmailTemplate", this.emailTemplate)
      }
    },
    updateTemplate(update) {
      if (this.emailTemplate) {
        this.emailTemplate.template = update
        this.hasChanged = true
        // Trigger live preview update
        this.renderLivePreview()
      }
    },
    updateHtmlValueInput(update) {
      console.log('[EmailTemplate] updateHtmlValueInput called with:', update)
      this.htmlValueInput = update
      if (this.emailTemplate) {
        // Validate that update is valid JSON before saving
        // If it's the placeholder text or empty, use empty object JSON
        if (!update || update === "Select an input case" || update.trim() === "") {
          this.emailTemplate.sampleInput = "{}"
          console.log('[EmailTemplate] Updated emailTemplate.sampleInput to {} (placeholder/empty)')
        } else {
          // Try to parse to validate it's valid JSON
          try {
            JSON.parse(update)
            this.emailTemplate.sampleInput = update
            console.log('[EmailTemplate] Updated emailTemplate.sampleInput (valid JSON)')
          } catch (e) {
            console.warn('[EmailTemplate] Invalid JSON in sampleInput, not saving:', e.message)
            // Don't save invalid JSON - keep the current value or use {}
            if (!this.emailTemplate.sampleInput || this.emailTemplate.sampleInput === "Select an input case") {
              this.emailTemplate.sampleInput = "{}"
            }
          }
        }
        // Trigger live preview update
        this.renderLivePreview()
      }
    },
    onIframeLoad() {
      console.log('[EmailTemplate] Iframe load event fired')
      const iframe = this.$refs.previewIframe
      if (!iframe) {
        console.warn('[EmailTemplate] Iframe ref not found')
        return
      }
      
      console.log('[EmailTemplate] Iframe src:', iframe.src)
      console.log('[EmailTemplate] Iframe contentWindow:', iframe.contentWindow)
      
      // Try to access iframe content (will fail if cross-origin)
      try {
        const doc = iframe.contentDocument || iframe.contentWindow.document
        console.log('[EmailTemplate] Iframe contentDocument accessible:', !!doc)
        if (doc) {
          console.log('[EmailTemplate] Iframe document title:', doc.title)
          console.log('[EmailTemplate] Iframe document body HTML length:', doc.body ? doc.body.innerHTML.length : 0)
          console.log('[EmailTemplate] Iframe document body preview:', doc.body ? doc.body.innerHTML.substring(0, 200) : 'N/A')
        }
      } catch (e) {
        console.warn('[EmailTemplate] Cannot access iframe contentDocument (cross-origin expected):', e.message)
        console.log('[EmailTemplate] This is normal for cross-origin iframes. Check Network tab to see the actual response.')
      }
      
      // Check iframe dimensions
      console.log('[EmailTemplate] Iframe dimensions:', {
        width: iframe.offsetWidth,
        height: iframe.offsetHeight,
        clientWidth: iframe.clientWidth,
        clientHeight: iframe.clientHeight
      })
      
      // Try to get iframe window location (might work even if contentDocument doesn't)
      try {
        const iframeWindow = iframe.contentWindow
        if (iframeWindow) {
          console.log('[EmailTemplate] Iframe window location:', iframeWindow.location.href)
        }
      } catch (e) {
        console.log('[EmailTemplate] Cannot access iframe window location (cross-origin):', e.message)
      }
    },
    onIframeError(event) {
      console.error('[EmailTemplate] Iframe error event fired:', event)
      console.error('[EmailTemplate] Error details:', {
        type: event.type,
        target: event.target,
        src: event.target && event.target.src
      })
    }
  },
  beforeDestroy() {
    // Clean up blob URL and debounce timer
    if (this.previewBlobURL) {
      URL.revokeObjectURL(this.previewBlobURL)
    }
    if (this.previewDebounceTimer) {
      clearTimeout(this.previewDebounceTimer)
    }
  }
}
</script>

<style scoped>
.template-editor-container {
  min-height: 400px;
}

.template-editor-container >>> .editr {
  border: 1px solid #e4e4e4;
  border-radius: 0 0 4px 4px;
  min-height: 400px;
}

.template-editor-container >>> .editr--content {
  min-height: 350px;
}

.source-toggle-toolbar-btn:hover {
  background: rgba(0,0,0,0.1);
}

.source-toggle-toolbar-btn:active {
  background: rgba(0,0,0,0.2);
}

.source-toggle-toolbar-btn .material-icons {
  font-size: 16px;
  line-height: 32px;
  vertical-align: middle;
}

.source-html-editor {
  border: 1px solid #e4e4e4;
  border-radius: 0 0 4px 4px;
  min-height: 400px;
}

.source-html-editor >>> textarea {
  font-family: 'Courier New', Courier, monospace;
  font-size: 13px;
}
</style>
